function asStringAttributes(object) {
  return Object.entries(object).map(([key, value]) => ({
    key,
    value: {
      stringValue: String(value)
    }
  }));
}
function asTypedAttributes(object) {
  return Object.entries(object).map(([key, value]) => ({
    key,
    value: asTypedValue(value)
  }));
}
function asTypedValue(value) {
  switch (typeof value) {
    case 'boolean':
      return {
        boolValue: Boolean(value)
      };
    case 'number':
      return Number.isInteger(value) ? {
        intValue: Number(value)
      } : {
        doubleValue: Number(value)
      };
    case 'string':
    default:
      return {
        stringValue: String(value)
      };
  }
}

export { asStringAttributes, asTypedAttributes };
